import React from 'react';
import helportMarkImg from '../favicon.png';

const HelportSupportAvatar = ({ className = '', alt = 'Helport Chat' }) => (
  <img
    src={helportMarkImg}
    alt={alt}
    className={`helport-support-avatar${className ? ` ${className}` : ''}`}
    draggable={false}
  />
);

export default HelportSupportAvatar;
